var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"home-layout"},[_c('v-row',[_c('v-col',{staticStyle:{"padding-top":"0"},attrs:{"cols":"12"}},[_c('transaction-list')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }